//=====================================================
//　ヘッダー
//=====================================================

import { useState } from 'react';
import { useContext } from 'react';
import { CtxAuth,  CtxClinicInfo } from '../../utils/Contexts';
import { HeaderConsulHours } from './HeaderConsulHours';
import { HeaderConsulHoursModal } from './HeaderConsulHoursModal';
import { LoginStatusType } from "../../utils/ConstCommon";
import { useHistory } from "react-router-dom";

export function Header(){
    const [showModal, setShowModal] = useState(false);
    const cci = useContext(CtxClinicInfo);
    const cua = useContext(CtxAuth);
    const history = useHistory();

    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };
 
    //医院名クリック処理
    function clickToTop() {
        if ( cua.checkExpiresIn() !== LoginStatusType.Login ) {
            //ログアウト、ログイン期限切れ
            cua.logout( function(){history.push("/")} );
        } else {
            //ログイン状態
            history.push("/mypage");
        }
    }

    return (
        <header>
            <div className="header-inner">
                <div className="header-inner-left">
                    <div className="header-system-title"><span>Web予約</span></div>
                    {cci.data.id && 
                        <>
                            <h1 className="header-dental-name" onClick={clickToTop}>{cci.data.name}</h1>
                            {cci.data.subName && <div className="header-dental-name-sub text-multiline">{cci.data.subName}</div>}
                        </>
                    }
                    {!cci.data.id && 
                        <h1 className="header-dental-name">DentNet 歯科Web予約システム</h1>
                    }
                </div>
                {cci.data.id && 
                    <div className="header-inner-right">
                        <div className="pc-parts">
                            <HeaderConsulHours />
                        </div>
                        { ( cci.data.consultationHoursImage || cci.data.consultationHours || cci.data.closedDays ) &&
                            <div className="sp-parts">
                                <div className="btn-dental-hours" onClick={openModal}><p className="icon icon-calendar"></p>診療時間</div>
                                <HeaderConsulHoursModal showModal={showModal} closeCallBack={closeModal} />
                            </div>
                        }
                    </div>
                }
            </div>
        </header>
    )
}